import { lazy } from "react";
import type { IndexRouteObject, RouteObject } from "react-router-dom";
import { Organizations } from "./pages/organizations/Organizations";

const DeviceActivity = lazy(() => import("./pages/account-security/DeviceActivity"));
const LinkedAccounts = lazy(() => import("./pages/account-security/LinkedAccounts"));
const SigningIn = lazy(() => import("./pages/account-security/SigningIn"));
const WifiPassword = lazy(() => import("./pages/account-security/WifiPassword"));
const Groups = lazy(() => import("./pages/groups/Groups"));
const PersonalInfo = lazy(() => import("./pages/personal-info/PersonalInfo"));
const ContentComponent = lazy(() => import("./pages/content/ContentComponent"));
const Dashboard = lazy(() => import("./pages/dashboard/Dashboard"));

export const DeviceActivityRoute: RouteObject = {
  path: "account-security/device-activity",
  element: <DeviceActivity />,
};

export const LinkedAccountsRoute: RouteObject = {
  path: "account-security/linked-accounts",
  element: <LinkedAccounts />,
};

export const SigningInRoute: RouteObject = {
  path: "account-security/signing-in",
  element: <SigningIn />,
};

export const WifiPasswordRoute: RouteObject = {
  path: "account-security/wifi-password",
  element: <WifiPassword />,
};

export const GroupsRoute: RouteObject = {
  path: "groups",
  element: <Groups />,
};

export type ContentComponentParams = {
  componentId: string;
};

export const ContentRoute: RouteObject = {
  path: "content/:componentId",
  element: <ContentComponent />,
};

export const PersonalInfoRoute: IndexRouteObject = {
  index: true,
  element: <PersonalInfo />,
  path: "personal-info",
};

export const OrganizationsRoute: RouteObject = {
  path: "organizations",
  element: <Organizations />,
};

export const DashboardRoute: RouteObject = {
  path: "",
  element: <Dashboard />,
};

export const routes: RouteObject[] = [
  PersonalInfoRoute,
  DeviceActivityRoute,
  LinkedAccountsRoute,
  SigningInRoute,
  GroupsRoute,
  OrganizationsRoute,
  PersonalInfoRoute,
  ContentRoute,
  WifiPasswordRoute,
  DashboardRoute,
];
